import React, {useState} from "react"
import {Button, Card, Form, Icon, Input, Layout, Spin} from "antd"
import {ReactComponent as Logo} from "../../assets/logo.svg"
import "./styles.scss"
import library from "../../library"

const {messages} = library

const Content = Layout.Content
const FormItem = Form.Item

type Props = {
	token: string,
	stage: string
}

export const ResetPasswordPage: React.FC<Props> = ({token, stage}: Props) => {
	if (stage === "password") stage = "production"
	const [email, decodedToken] = atob(token).split("%"),
		[loading, setLoading] = useState(false),
		[password, setPassword] = useState(""),
		[confirm, setConfirm] = useState(""),
		[responseReceived, setResponseReceived] = useState(false),
		[errorMessage, setErrorMessage] = useState("")

	const handleSubmit = async (e: React.MouseEvent<any>) => {
		e.preventDefault()
		setLoading(true)
		try {
			if (password !== confirm) throw new Error(messages.PASSWORD_MISMATCH)
			if (password.length < 8) throw new Error(messages.INVALID_PASSWORD)
			if (!RegExp("^[a-zA-Z0-9]*$").test(password)) throw new Error(messages.INVALID_PASSWORD)
			const response = await library.postQuery(`mutation { resetPassword( password:"${password}", email:"${email}", token:"${decodedToken}") }`, stage)
			if (response.resetPassword.success) {
				setResponseReceived(true)
			} else {
				setLoading(false)
				setErrorMessage(messages.PASSWORD_RESET_FAILED)
			}
		} catch (error) {
			setErrorMessage(error.message)
			setLoading(false)
		}
	}

	return (
		<Content className={"content-wrap"}>
			{loading ? responseReceived ? <div><Icon type={"check"}/> 新しいパスワードが設定されました。もう一度ログインしてください。 </div> :
				<Spin size={"large"}/> : <Card className={"card"}>

				<div className={"logo-wrap"}>
					<Logo className={"logo"}/>
				</div>
				<p style={{marginBottom: "2em"}}>
					「{email}」に関連付けられたアカウントの、パスワードをリセットします。
				</p>
				<Form onSubmit={handleSubmit} className="login-form">
					<FormItem>
						<Input
							type={"password"}
							prefix={
								<Icon
									type="lock"
									style={{
										fontSize: 13,
									}}
								/>
							}
							value={password}
							onChange={e => {
								setPassword(e.target.value)
							}}
							placeholder="新しいパスワード"
						/>
					</FormItem>
					<FormItem>
						<Input
							type={"password"}
							prefix={
								<Icon
									type="lock"
									style={{
										fontSize: 13,
									}}
								/>
							}
							value={confirm}
							onChange={e => {
								setConfirm(e.target.value)
							}}
							placeholder="新しいパスワード（再入力）"
						/>

					</FormItem>
					{errorMessage && <p className={"error-message-text"}>{errorMessage}</p>}
					<FormItem>
						<Button
							className={"full-width"}
							type="primary"
							htmlType="submit"
							size="large">
							パスワードをリセットする
						</Button>
					</FormItem>
				</Form>
			</Card>}
		</Content>
	)
}

export default ResetPasswordPage
